export default function create(options) {
  const easing = 'sineOut';
  const {
    scale = 0.7
  } = options.namedEffect;
  return [{
    ...options,
    easing: 'linear',
    part: 'BG_LAYER',
    startOffset: {
      name: 'exit',
      offset: {
        type: 'percentage',
        value: 0
      }
    },
    endOffset: {
      name: 'exit',
      offset: {
        type: 'percentage',
        value: 100
      }
    },
    keyframes: [{
      opacity: 1
    }, {
      opacity: 0
    }]
  }, {
    ...options,
    easing,
    part: 'BG_LAYER',
    startOffset: {
      name: 'exit',
      offset: {
        type: 'percentage',
        value: 0
      }
    },
    endOffset: {
      name: 'exit',
      offset: {
        type: 'percentage',
        value: 50
      }
    },
    keyframes: [{
      scale: 1
    }, {
      scale
    }]
  }];
  /*
   * @keyframes <name>-fade {
   *   from {
   *     opacity: <opacityFrom>;
   *   }
   *   to {
   *     opacity: <opacityTo>;
   *   }
   * }
   *
   * @keyframes <name>-zoom {
   *   from {
   *     scale: 1;
   *   }
   *   to {
   *     scale: 0.7;
   *   }
   * }
   */
}
//# sourceMappingURL=BgFadeBack.js.map